



















































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyGeneralDetailsEdit from '@/components/Agencies/AgencyGeneralDetailsEdit.vue';
import AgencyProfileDetailsEdit from '@/components/Agencies/AgencyProfileDetailsEdit.vue';
import AgencyAvatarEdit from '@/components/Agencies/AgencyAvatarEdit.vue';
import { AppModule } from '@/store/modules/app';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'AgencyDetails',
  components: { AgencyGeneralDetailsEdit, AgencyProfileDetailsEdit, AgencyAvatarEdit }
})
export default class extends GiganautVue {

	get avatarUrl() {
		return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/1/" + AppModule.currentAgencyContext.id + "/" + AgencySettingsModule.agency.avatar;
	}

	get avatarThumbnailUrl() {
		return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/1/" + AppModule.currentAgencyContext.id + "/resized-100/" + AgencySettingsModule.agency.avatar;
  	}

  	get agency() {
		return AgencySettingsModule.agency;
  	}
}
